import { defineMessages } from 'react-intl';

export default defineMessages({
  about: {
    id: 'cboard.components.About.about',
    defaultMessage: 'About'
  },
  intro: {
    id: 'cboard.components.About.intro',
    defaultMessage:
      'Cboard is an augmentative and alternative communication (AAC) web application, allowing people with speech and language impairments to communicate by symbols and text-to-speech.'
  },
  contributors: {
    id: 'cboard.components.About.contributors',
    defaultMessage: 'Contributors'
  },
  license: {
    id: 'cboard.components.About.license',
    defaultMessage: 'License'
  },
  resources: {
    id: 'cboard.components.About.resources',
    defaultMessage: 'Resources'
  },
  copyright: {
    id: 'cboard.components.About.copyright',
    defaultMessage: 'Copyright © 2017-2024, Assistive Communication LLC.'
  },
  contribute: {
    id: 'cboard.components.About.contribute',
    defaultMessage: 'Contribute'
  },
  contributeText: {
    id: 'cboard.components.About.contributeText',
    defaultMessage:
      'Cboard is an open-source software and you can collaborate with our mission of democratize access to AAC for everyone. Please join us on Github:'
  },
  thanks: {
    id: 'cboard.components.About.thanks',
    defaultMessage: 'Special Thanks'
  },
  thanksBody: {
    id: 'cboard.components.About.thanksBody',
    defaultMessage:
      'Cboard is possible thanks to the fantastic support of UNICEF and Microsoft. We always appreciate their confidence and financial support.'
  }
});
